import { useRef } from "react";
import { useAutoScrollBottom } from "hooks";
import { Collection } from "ui/support/Resource";
import { NoDataOverlay } from "ui/molecules/TableGrids";
import { useCommentContext } from "../../../providers";
import CommentMessage from "./CommentMessage";

const CommentBoxComments = () => {
    const { comments } = useCommentContext();

    const containerRef = useRef<HTMLDivElement>(null);

    useAutoScrollBottom(containerRef, comments);

    return (
        <Collection
            ref={containerRef}
            sx={{
                maxHeight: 150,
                overflowY: 'auto',
                p: 1,
                display: 'grid',
                alignItems: 'flex-start',
                gap: 1
            }}
            collection={comments}
            isEmpty={!comments.length}
            emptySlot={(
                <NoDataOverlay>
                    Looks like you haven't added any comments yet...
                </NoDataOverlay>
            )}
            renderResource={(_, index) => (
                <CommentMessage
                    key={index}
                    index={Number(index)}
                />
            )}
        />
    );
};

export default CommentBoxComments;
